/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateDocumentRequestDocumentFromJSON, UpdateDocumentRequestDocumentToJSON } from './UpdateDocumentRequestDocument';
export function UpdateDocumentRequestFromJSON(json) {
    return UpdateDocumentRequestFromJSONTyped(json, false);
}
export function UpdateDocumentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        document: !exists(json, 'document') ? undefined : UpdateDocumentRequestDocumentFromJSON(json['document'])
    };
}
export function UpdateDocumentRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document: UpdateDocumentRequestDocumentToJSON(value.document)
    };
}
